import { render, staticRenderFns } from "./ProjectsView.vue?vue&type=template&id=4bfc349a&scoped=true&"
import script from "./ProjectsView.vue?vue&type=script&lang=js&"
export * from "./ProjectsView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsView.vue?vue&type=style&index=0&id=4bfc349a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfc349a",
  null
  
)

export default component.exports